import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { href: "#buch", label: "Das Buch", id: "buch" },
  { href: "#inhalte", label: "Inhalte", id: "inhalte" },
  { href: "#zielgruppen", label: "Zielgruppen", id: "zielgruppen" },
  { href: "#autor", label: "Autor", id: "autor" },
  { href: "#bestellen", label: "Bestellen", id: "bestellen" },
];

const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-[background-color,border-color] duration-300 ${
        scrolled || open
          ? "bg-navy-950/85 backdrop-blur-xl border-b border-white/5"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <nav
        className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between"
        aria-label="Hauptnavigation"
      >
        <a
          href="#start"
          data-testid="nav-logo"
          className="font-display font-extrabold text-lg tracking-tight text-white"
        >
          Blaulicht<span className="text-blau">Praxis</span>
        </a>

        <div className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.id}
              href={l.href}
              data-testid={`nav-link-${l.id}`}
              className="text-sm text-gray-300 hover:text-white transition-colors duration-200"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#bestellen"
            data-testid="nav-cta-order"
            className="ml-2 inline-flex items-center rounded-full bg-blau px-5 py-2.5 text-sm font-semibold text-white transition-[background-color,transform,box-shadow] duration-200 hover:bg-blau-glow hover:text-navy-950 hover:-translate-y-0.5 hover:shadow-[0_8px_30px_-6px_rgba(0,102,255,0.7)]"
          >
            Buch bestellen
          </a>
        </div>

        <button
          type="button"
          data-testid="nav-mobile-toggle"
          aria-label={open ? "Menü schließen" : "Menü öffnen"}
          aria-expanded={open}
          onClick={() => setOpen(!open)}
          className="lg:hidden text-white p-2"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </nav>

      {open && (
        <div className="lg:hidden border-t border-white/5 bg-navy-950/95 backdrop-blur-xl">
          <div className="px-6 py-6 flex flex-col gap-5">
            {links.map((l) => (
              <a
                key={l.id}
                href={l.href}
                data-testid={`nav-mobile-link-${l.id}`}
                onClick={() => setOpen(false)}
                className="text-base text-gray-200 hover:text-white"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#bestellen"
              data-testid="nav-mobile-cta-order"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex w-fit items-center rounded-full bg-blau px-6 py-3 text-sm font-semibold text-white"
            >
              Buch bestellen
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Nav;
